import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ClientesComerciales } from 'src/app/proforma/domain/response/proforma_response';

interface Grupo {
  grupo_id: number;
  nombre_grupo: string;
  expandido: boolean;
  clientes: ClientesComerciales[];
}
// Para usar en el tipo de las señales
type ItemAsignacion = ClientesComerciales | Grupo;

@Component({
  selector: 'app-custom-picklist',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,InputTextModule,TextareaModule],
  templateUrl: './custom-picklist.component.html',
  styleUrl: './custom-picklist.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomPicklistComponent {

  // Inputs: Propiedades de solo lectura que vienen del padre
  formularioDelPadre = input.required<FormGroup>()
  sourceItems = input<any[]>([]);
  targetItems = input<any[]>([]);
  sourceHeader = input<string>('Disponibles');
  targetHeader = input<string>('Seleccionados');
  filterBy = input<string>('');

  // Nuevo input para recibir la lista del select
  clientTypes = input<any[]>([]);

  // ✅ Nuevos inputs para filtros
  showGroups = input<boolean>(true);
  showClients = input<boolean>(true);

  // Outputs: Eventos que se emiten para que el padre los escuche
  sourceFilterChange = output<string>();
  targetFilterChange = output<string>();
  selectItem = output<any>();
  deselectItem = output<any>();
  // Nuevo output para el select
  clientTypeFilterChange = output<string>();

  // ✅ Nuevos outputs para checkboxes
  showGroupsChange = output<boolean>();
  showClientsChange = output<boolean>();

  // Función para verificar si un ítem es un Grupo
  esGrupo(item: ItemAsignacion): item is Grupo {
    // La verificación por la existencia de la propiedad 'clientes' es más fiable.
    return (item as Grupo).clientes !== undefined;
  }

  // Función de trackBy actualizada
  getTrackByValue(item: ItemAsignacion): number | string {
    if (this.esGrupo(item)) {
      return item.grupo_id;
    } else {
      return item.entC_Codigo;
    }
  }

  toggleGrupo(item: ItemAsignacion) {
    if (this.esGrupo(item)) {
      item.expandido = !item.expandido;
    }
  }
}
